import { Directive, Input, ElementRef, HostListener, OnChanges } from '@angular/core';

@Directive({ selector: 'auto-size, [auto-size]' })
export class ElementAutoSize implements OnChanges {

    @Input()
    public value: string;

    constructor(private element: ElementRef) {
    }

    public ngOnChanges(changes: any): void {
        if (changes.value) {
            this.resize();
        }
    }

    @HostListener("window:keyup") onKeyUp(): void {
        this.resize();
    }

    public resize(): void {
        let nativeElement = this.element.nativeElement;
        nativeElement.style.overflow = 'hidden';
        nativeElement.style.height = 'auto';
        nativeElement.setAttribute("overflow", "hidden");
        if (!String.isNullOrEmpty(this.value))
            nativeElement.style.height = nativeElement.scrollHeight + "px";
    }

}


// WEBPACK FOOTER //
// ./app/common/directives/elementAutoSize.directive.ts